import { useState, useEffect } from "react";

export function useClock(intervalMs = 10000) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

export function fmtTime(d) {
  if (!d) return "—";
  const dateObj = typeof d === "string" ? new Date(d) : d;
  if (isNaN(dateObj.getTime())) return typeof d === "string" ? d : "—";

  return dateObj.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hour12: true });
}

export function fmtDate(d) {
  if (!d) return "—";
  const dateObj = typeof d === "string" ? new Date(d) : d;
  if (isNaN(dateObj.getTime())) return typeof d === "string" ? d : "—";

  return dateObj.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric" });
}

export function getTopClockTime(d = new Date()) {
  return `${fmtTime(d)} (${fmtDate(d)})`;
}

export function formatClientDisplayTime(str) {
  if (!str || typeof str !== "string") return str || "—";
  return str;
}
